export default () => ({
  entity: 'policy',
  entities: 'policies',
  currentEntity: {},
  policies: [],
  errors: {
  }
})



// WEBPACK FOOTER //
// ./src/app/patient/privacy-policy/index/resources/data.js